<aside class="flex h-full min-h-0 flex-col justify-center gap-10 overflow-y-auto bg-linear-to-br from-brand-studio-dark to-brand-studio px-10 py-16 text-white">
  <div class="flex max-w-xl flex-col gap-5">
    <p class="m-0 text-sm font-bold uppercase tracking-widest">SHOUT Studio</p>
    <h2 class="use-grotesque m-0 origin-bottom-left -skew-x-6 text-5xl font-bold leading-none tracking-tight xl:text-7xl">Turn up the volume.</h2>
    <p class="m-0 text-2xl font-semibold leading-tight">Your briefs, creators and results are waiting. Sign in and keep the momentum going.</p>
  </div>

  <ul class="m-0 flex max-w-xl list-none flex-col gap-3.5 p-0 text-xl font-bold">
    @for (pillar of pillars; track pillar) {
      <li class="flex items-center gap-3.5">
        <span class="flex size-7 shrink-0 items-center justify-center rounded-full bg-white text-sm font-black text-brand-studio-dark" aria-hidden="true">✓</span>
        {{ pillar }}
      </li>
    }
  </ul>

  <div class="flex max-w-xl flex-col gap-3">
    <p class="m-0 text-base font-semibold">Trusted by the world's most innovative teams</p>
    <div class="mt-3 flex flex-wrap items-center justify-between gap-x-6 gap-y-4">
      <img src="/assets/logos/cloud/adobe_dark.svg" alt="Adobe" class="h-8 w-auto brightness-0 invert xl:h-10" />
      <img src="/assets/logos/cloud/byd_dark.svg" alt="BYD" class="h-4 w-auto brightness-0 invert xl:h-5" />
      <img src="/assets/logos/cloud/golin_dark.svg" alt="GOLIN" class="h-5 w-auto brightness-0 invert xl:h-7" />
      <img src="/assets/logos/cloud/pizzahut_dark.svg" alt="Pizza Hut" class="h-5 w-auto brightness-0 invert xl:h-6" />
      <img src="/assets/logos/cloud/monday_dark.svg" alt="monday.com" class="h-4 w-auto brightness-0 invert xl:h-5" />
    </div>
  </div>
</aside>
